import { Box, ModBox, Spacer, Text } from '@jfs/ui-new'
import { useIsFocused, useNavigation } from '@react-navigation/core'
import React, { useCallback, useEffect, useState } from 'react'
import { EmType } from '../..'
import { Dropdown } from '../../../../components/Dropdown'
import { RootStore, useLazyApiData, useStores } from '../../../../data/store'
import { MessageTypes } from '../../../../utils'
import {
  createEntityMASMIDHeaders,
  createEntityMIDMASMapper,
  createEntityPIDHeaders,
  createEntityflexMapper,
} from './ParentEntityDetails/Fixtures'
import { SearchParentEntity } from './SearchParentEntity'
import { SelectParentEntityList } from './SelectParentEntityList'
import { flexMapperWithIndex, headerData, subGrpheaderData } from './SelectParentEntityList/Fixtures'
import { styles } from './styles'

const PADDING_HORIZONTAL = 40
const PADDING_VERTICAL = 32

interface CreateEntityProps {
  type: string
  isValidToProceed: (isValid: boolean) => void
  setIsLinkToMAS?: (isLinkToMas: boolean) => void
  isReset: boolean
  getSelectedEntity?: (selectedEntity: any) => void
}

const CreateEntity = React.memo(
  ({ type, isValidToProceed, setIsLinkToMAS, isReset, getSelectedEntity }: CreateEntityProps) => {
    const {
      setEmsFlow,
      setGroupSelected,
      setEntityGrpIdSelected,
      setParentEntityIdSelected,
      fetchGroupsList,
      fetchSubGroupsList,
      fetchEntityDetailsGetMerchant,
      searchData,
      groupsList,
      fetchSearchEntity,
      getSearchedMasEntityData,
      setParentTypeSelectedToStore,
      setSearchedMasMid,
      entityDetails,
      setEmsParentEntityId,
      resetSearchEntity,
      selectedEntityParentType,
      getCreationDataByStep,
      setSubGroupSelectedData,
      subGroupsList,
      resetSubGroupSelectedName,
      fetchAllLovs,
      checkIfLovsHasThisKey,
      setViewDetailsSearchFlow,
    } = useStores((store) => ({
      setEmsFlow: store.onboarding.setEmsFlow,
      setGroupSelected: store.onboarding.setGroupSelected,
      setEntityGrpIdSelected: store.onboarding.setEntityGrpIdSelected,
      setParentEntityIdSelected: store.onboarding.setParentEntityIdSelected,
      getSearchDevices: store.fetchSearchDevices,
      fetchGroupsList: store.getGroupsList,
      fetchSubGroupsList: store.getSubGroupsList,
      fetchEntityDetailsGetMerchant: store.fetchEntityDetailsGetMerchant,
      searchData: store.getSearchData,
      groupsList: store.onboarding.getGroupsList,
      fetchSearchEntity: store.fetchSearchEntity,
      getSearchedMasEntityData: store.getSearchedMasEntityData,
      setParentTypeSelectedToStore: store.onboarding.setParentTypeSelectedToStore,
      setSearchedMasMid: store.onboarding.setSearchedMasMid,
      entityDetails: store.onboarding.entityDetails,
      setEmsParentEntityId: store.onboarding.setEmsParentEntityId,
      resetSearchEntity: store.resetSearchEntity,
      selectedEntityParentType: store.onboarding.entityParentType,
      getCreationDataByStep: store.onboarding.getCreationDataByStep,
      setSubGroupSelectedData: store.onboarding.setSubGroupSelectedData,
      subGroupsList: store.onboarding.getGroupsListFetched,
      resetSubGroupSelectedName: store.onboarding.resetSubGroupSelectedName,
      fetchAllLovs: store.fetchAllLovs,
      checkIfLovsHasThisKey: store.checkIfLovsHasThisKey,
      setViewDetailsSearchFlow: store.onboarding.setViewDetailsSearchFlow,
    }))

    const [fetchGroups, fetchGroupsListHandler] = useLazyApiData(fetchGroupsList)
    const [fetchSubGroups, fetchSubGroupsListHandler] = useLazyApiData(fetchSubGroupsList)
    const [fetchEntityByGetMerchantApi, fetchGetMerchantHandler] = useLazyApiData(fetchEntityDetailsGetMerchant)
    const [fetchSearch, fetchSearchHandler] = useLazyApiData(fetchSearchEntity)

    const [groupListCalled, setGroupListCalled] = useState(false)
    const [parentTypeSelected, setParentTypeSelected] = useState('')
    const [showMasMidSearch, setShowMasMidSearch] = useState(false)
    const [showMasMidSearchResults, setShowMasMidSearchResults] = useState(false)
    const [showEntSerchResults, setShowEntSerchResults] = useState(false)
    const [isParentTypeSubGrpSelected, setIsParentTypeSubGrpSelected] = useState(false)
    const [showSearchParentByEntId, setShowSearchParentByEntId] = useState(false)
    const [groupSelectedTitle, setGroupSelectedTitle] = useState('')
    const [subGroupSelectedTitle, setSubGroupSelectedTitle] = useState('')
    const [searchListData, setSearchListData] = useState([])
    const [groupsListData, setGroupsListData] = useState([])
    const [subGroupsListData, setSubGroupsListData] = useState([])
    const [parentEntitySearchId, setParentEntitySearchString] = useState('')
    const [isMasMidCleared, setIsMasMidCleared] = useState(false)
    const [clearSearchMasMidText, setClearMasMidText] = useState(false)
    const [entityData, setEntityData] = useState([])
    const [masMid, setMasMid] = useState('')
    const [isGetEntityCalled, setGetEntityCalled] = useState(false)
    const [enteredData, setEnteredData] = useState(undefined)
    const [isSelectionsCleared, setSelectionsCleared] = useState(false)
    const [searchedMidSource, setSearchedMidSource] = useState('')

    const navigation = useNavigation()

    const isFocus = useIsFocused()

    const onClearPressed = () => {
      setSearchedMasMid('')
      setShowMasMidSearchResults(false)
      setIsLinkToMAS && setIsLinkToMAS(false)
      setIsMasMidCleared(true)
      setMasMid('')
    }

    useEffect(() => {
      if (type === EmType.createSubGroup) {
        const data = getCreationDataByStep(1)
        setGroupSelectedTitle(data?.subGroupListSelectedName)
      }
    }, [type])

    useEffect(() => {
      if (type === EmType.createSingleEntity) {
        const data = getCreationDataByStep(1)
        console.log('===> enteredData', data)
        if (
          data !== undefined &&
          data?.searchedMasMid?.length >= 0 &&
          (data?.emsParentEntityIdentificationNumber?.length > 0 || data?.selectedSubGroupId?.length > 0) &&
          parentTypeSelected === '' &&
          enteredData === undefined &&
          !isSelectionsCleared
        ) {
          setEnteredData(data)
          if (data?.entityParentType === 'SubGroup') {
            setParentTypeSelected('SubGroup')
          } else {
            setParentTypeSelected('Entity')
            setShowSearchParentByEntId(true)
          }
          if (data?.selectedSubGroupId?.length > 0) {
            const datalist = groupsList()
            setGroupsListData(datalist)
            setGroupSelectedTitle(data?.selectedSubGroupName)
            setSubGroupSelectedTitle(data?.subGroupListSelectedName)
            setSubGroupsListData(subGroupsList())
            setShowEntSerchResults(true)
            setShowMasMidSearch(true)
          }
          if (data?.emsParentEntityIdentificationNumber?.length > 0) {
            const datalist = searchData(EmType.createSingleEntity)
            setSearchListData(datalist)
            setEmsParentEntityId(data?.emsParentEntityIdentificationNumber)
            setParentEntitySearchString(data?.emsParentEntityIdentificationNumber)
            setShowEntSerchResults(true)
            setShowMasMidSearch(true)
          }
          if (data?.searchedMasMid?.length > 0) {
            setShowMasMidSearchResults(true)
            setShowMasMidSearch(true)
            setShowEntSerchResults(true)
            setParentEntityIdSelected(data?.searchedMasMid)
            setMasMid(data?.searchedMasMid)
            const entityDataList = getSearchedMasEntityData()
            getSelectedEntity && getSelectedEntity(entityDataList[0])
            setEntityData(entityDataList)
          }
        } else if (
          data !== undefined &&
          data?.entityParentType === 'SubGroup' &&
          data?.selectedParentEntityName?.length > 0 &&
          data?.selectedSubGroupName?.length > 0 &&
          data?.subGroupListSelectedName?.length > 0
        ) {
          setGroupsListData(groupsList())
          setSubGroupsListData(subGroupsList())
          setGroupSelectedTitle(data?.selectedSubGroupName)
          setSubGroupSelectedTitle(data?.subGroupListSelectedName)
        }
      }
    }, [
      enteredData,
      getCreationDataByStep,
      getSearchedMasEntityData,
      getSelectedEntity,
      groupsList,
      isSelectionsCleared,
      parentTypeSelected,
      searchData,
      setEmsParentEntityId,
      setParentEntityIdSelected,
      subGroupsList,
      type,
    ])

    useEffect(() => {
      if (type === EmType.createSubGroup && isFocus) {
        if (groupsList().length === 0 && !groupListCalled) {
          fetchGroups('')
          setGroupListCalled(true)
        } else {
          const datalist = groupsList()
          setGroupsListData(datalist)
        }
      } else if (type === EmType.createSingleEntity) {
        if (!checkIfLovsHasThisKey('Status')) {
          fetchAllLovs(...['Status'])
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fetchGroups, groupsList, type, isFocus])

    useEffect(() => {
      if (fetchGetMerchantHandler.state === 'fulfilled' && !showMasMidSearchResults && !isMasMidCleared) {
        if (fetchGetMerchantHandler.data instanceof Object || fetchGetMerchantHandler.data instanceof Array) {
          // SMID Case masParentId === identificationNumber
          if (
            fetchGetMerchantHandler?.data?.findEntity?.entity?.masParentId ===
            fetchGetMerchantHandler?.data?.findEntity?.entity?.identificationNumber
          ) {
            console.log('searchedMidSource', searchedMidSource)
            if (searchedMidSource === 'EMS') {
              //Allow case 2.2.1
            } else if (searchedMidSource === 'MAS') {
              if (parentEntitySearchId?.length > 0 && !isParentTypeSubGrpSelected) {
                RootStore.message.setMessage(
                  `Please attach ${fetchGetMerchantHandler?.data?.findEntity?.entity?.identificationNumber} to EMS only entity or Sub Group`,
                  MessageTypes.INFO,
                )
                setShowMasMidSearchResults(false)
                setIsLinkToMAS && setIsLinkToMAS(false)
                setIsMasMidCleared(true)
                setSearchedMasMid('')
                setClearMasMidText(true)
                isValidToProceed && isValidToProceed(false)
                setMasMid('')
                return
              }
            }
          } else {
            //  MID case masParentId !== identificationNumber
            if (
              !isParentTypeSubGrpSelected &&
              parentEntitySearchId?.length > 0 &&
              fetchGetMerchantHandler?.data?.findEntity?.entity?.masParentId !== parentEntitySearchId
            ) {
              if (searchedMidSource === 'MAS') {
                RootStore.message.setMessage('Please select the correct parent id for the MAS Mid', MessageTypes.INFO)
                setShowMasMidSearchResults(false)
                setIsLinkToMAS && setIsLinkToMAS(false)
                setIsMasMidCleared(true)
                setSearchedMasMid('')
                setClearMasMidText(true)
                isValidToProceed && isValidToProceed(false)
                setMasMid('')
                return
              } else if (searchedMidSource === 'EMS') {
                RootStore.message.setMessage(
                  `Please attach to the correct parent ${fetchGetMerchantHandler?.data?.findEntity?.entity?.masParentId}`,
                  MessageTypes.INFO,
                )
                setShowMasMidSearchResults(false)
                setIsLinkToMAS && setIsLinkToMAS(false)
                setIsMasMidCleared(true)
                setSearchedMasMid('')
                setClearMasMidText(true)
                isValidToProceed && isValidToProceed(false)
                setMasMid('')
                return
              }
            } else if (
              isParentTypeSubGrpSelected &&
              fetchGetMerchantHandler?.data?.findEntity?.entity?.masParentId !== parentEntitySearchId
            ) {
              RootStore.message.setMessage(
                `Please onboard the MAS Parent ID: ${fetchGetMerchantHandler?.data?.findEntity?.entity?.masParentId}`,
                MessageTypes.INFO,
              )
              setShowMasMidSearchResults(false)
              setIsLinkToMAS && setIsLinkToMAS(false)
              setIsMasMidCleared(true)
              setSearchedMasMid('')
              setClearMasMidText(true)
              isValidToProceed && isValidToProceed(false)
              setMasMid('')
              return
            }
          }
          if (fetchGetMerchantHandler?.data?.findEntity?.entity?.identificationNumber === masMid) {
            const data = getSearchedMasEntityData()
            console.log('entity data: ', data)
            if (fetchSearchHandler.state === 'pending') {
              return
            }
            getSelectedEntity && getSelectedEntity(data[0])
            setEntityData(data)
            setShowMasMidSearchResults(true)
            isValidToProceed(true)
            setIsLinkToMAS && setIsLinkToMAS(true)
            setSearchedMasMid(entityDetails?.entity?.identificationNumber)
            if (!isParentTypeSubGrpSelected) {
              setParentEntityIdSelected(data[0])
            }
            setIsMasMidCleared(false)
          }
        } else {
          if (fetchSearchHandler.state === 'rejected' && fetchSearchHandler.data !== "Record doesn't exist") {
            setShowMasMidSearchResults(false)
            setIsLinkToMAS && setIsLinkToMAS(false)
            setIsMasMidCleared(true)
            setSearchedMasMid('')
            setParentEntityIdSelected('')
            setClearMasMidText(true)
            setEntityData([])
          }
        }
      } else if (fetchGetMerchantHandler.state === 'rejected') {
        if (fetchSearchHandler.state !== 'pending') {
          setSearchedMasMid('')
          setParentEntityIdSelected('')
          setShowMasMidSearchResults(false)
          setIsLinkToMAS && setIsLinkToMAS(false)
          setIsMasMidCleared(true)
          setEntityData([])
        }
      } else if (
        (fetchGetMerchantHandler.state === 'fulfilled' &&
          (typeof fetchGetMerchantHandler.data === 'string' || fetchGetMerchantHandler.data instanceof String) &&
          showMasMidSearchResults) ||
        (fetchGetMerchantHandler.data &&
          fetchGetMerchantHandler?.data?.traceId &&
          fetchGetMerchantHandler?.data?.traceId?.length > 0 &&
          fetchGetMerchantHandler?.data?.error &&
          fetchGetMerchantHandler?.data?.error?.length > 0)
      ) {
        setShowMasMidSearchResults(false)
        setIsLinkToMAS && setIsLinkToMAS(false)
        setIsMasMidCleared(true)
        setSearchedMasMid('')
        setParentEntityIdSelected('')
        setClearMasMidText(true)
        setEntityData([])
      }
    }, [
      entityDetails?.entity?.identificationNumber,
      fetchGetMerchantHandler,
      fetchGetMerchantHandler.data,
      fetchGetMerchantHandler.state,
      fetchSearchHandler.data,
      fetchSearchHandler.state,
      getSearchedMasEntityData,
      getSelectedEntity,
      isMasMidCleared,
      isValidToProceed,
      setIsLinkToMAS,
      setParentEntityIdSelected,
      setSearchedMasMid,
      showMasMidSearchResults,
    ])

    useEffect(() => {
      if (fetchGroupsListHandler.state === 'fulfilled' && groupsListData.length === 0) {
        const datalist = groupsList()
        setGroupsListData(datalist)
        setGroupListCalled(false)
      } else if (fetchGroupsListHandler.state && fetchGroupsListHandler.state !== 'pending') {
        setGroupListCalled(false)
      }
    }, [fetchGroupsListHandler.state, groupsList, groupsListData.length])

    useEffect(() => {
      if (fetchSubGroupsListHandler.state === 'fulfilled' && fetchSubGroupsListHandler.data !== undefined) {
        setSubGroupsListData(fetchSubGroupsListHandler.data)
      }
    }, [fetchSubGroupsListHandler.data, fetchSubGroupsListHandler.state, subGroupsListData.length])

    const resetSelections = useCallback(() => {
      setShowMasMidSearch(false)
      setShowEntSerchResults(false)
      setShowMasMidSearchResults(false)
      setIsParentTypeSubGrpSelected(false)
      setShowSearchParentByEntId(false)
      setGroupSelectedTitle('')
      setSubGroupSelectedTitle('')
      setGroupListCalled(false)
      setParentTypeSelected('')
      setSearchListData([])
      if (type !== EmType.createSubGroup) {
        setGroupsListData([])
      }
      setSubGroupsListData([])
      setParentEntitySearchString('')
      setEntityData([])
      if (type === EmType.createSingleEntity) {
        resetSearchEntity()
        navigation.reset({
          index: 0,
          routes: [{ name: 'createSingleEntity' }],
        })
      }
      setEnteredData(undefined)
      setEmsParentEntityId('')
      setParentEntityIdSelected('')
      setMasMid('')
      setSelectionsCleared(true)
      resetSubGroupSelectedName('')
    }, [
      navigation,
      resetSearchEntity,
      resetSubGroupSelectedName,
      setEmsParentEntityId,
      setParentEntityIdSelected,
      type,
    ])

    useEffect(() => {
      if (isReset) {
        resetSelections()
      }
    }, [isReset, resetSelections])

    useEffect(() => {
      const data = searchData(EmType.createSingleEntity)
      if (
        fetchSearchHandler.state === 'fulfilled' &&
        !showEntSerchResults &&
        parentEntitySearchId.length > 0 &&
        fetchSearchHandler?.data?.traceId === undefined
      ) {
        if (data.length > 0 && Array.isArray(fetchSearchHandler?.data?.findEntity?.entitySearchList)) {
          setShowEntSerchResults(true)
          setSearchListData(data)
          if (type === EmType.createSingleEntity) {
            setEmsParentEntityId(parentEntitySearchId)
            setEntityGrpIdSelected(data[0])
            setGroupSelected({ legalName: data[0]?.group ?? '' })
            setShowMasMidSearchResults(false)
            setSearchedMidSource(fetchSearchHandler?.data?.findEntity?.entitySearchList?.[0]?.entity?.source)
            if (data?.[0]?.status === 'TERMINATED') {
              isValidToProceed && isValidToProceed(false)
              setShowMasMidSearch(false)
            } else {
              if (selectedEntityParentType === 'Entity') {
                isValidToProceed && isValidToProceed(true)
                setShowMasMidSearch(true)
              }
            }
          }
        } else if (typeof fetchSearchHandler?.data === 'string') {
          setShowEntSerchResults(false)
          setSearchListData([])
          isValidToProceed && isValidToProceed(false)
        }
      } else if (
        fetchSearchHandler.state === 'fulfilled' &&
        showEntSerchResults &&
        (parentEntitySearchId.length > 0 || isParentTypeSubGrpSelected)
      ) {
        if (
          data?.length > 0 &&
          data[0]?.id?.length > 0 &&
          data[0]?.businessName?.length === 0 &&
          data[0]?.type?.length === 0 &&
          data[0]?.status?.length === 0
        ) {
          if (fetchSearchHandler.data !== "Record doesn't exist") {
            RootStore.message.setMessage('MAS MID already exists', MessageTypes.ERROR)
            console.count('===> MAS MID already exists shown count: ')
            setShowMasMidSearchResults(false)
            setIsLinkToMAS && setIsLinkToMAS(false)
            setIsMasMidCleared(true)
            setSearchedMasMid('')
            setClearMasMidText(true)
            isValidToProceed && isValidToProceed(false)
          } else {
            if (entityData.length >= 0 && !isGetEntityCalled) {
              fetchEntityByGetMerchantApi(masMid, 'ALL')
              console.count('===> fetchEntityByGetMerchantApi called count: ')
              setGetEntityCalled(true)
            }
          }
        } else if (fetchSearchHandler.data === "Record doesn't exist") {
          if (entityData.length >= 0 && !isGetEntityCalled) {
            fetchEntityByGetMerchantApi(masMid, 'ALL')
            console.count('===> fetchEntityByGetMerchantApi called count: ')
            setGetEntityCalled(true)
          }
        }
      }
    }, [
      entityData.length,
      fetchEntityByGetMerchantApi,
      fetchSearchHandler.data,
      fetchSearchHandler.state,
      isGetEntityCalled,
      isParentTypeSubGrpSelected,
      isValidToProceed,
      masMid,
      parentEntitySearchId,
      searchData,
      searchListData.length,
      selectedEntityParentType,
      setEmsParentEntityId,
      setEntityGrpIdSelected,
      setGroupSelected,
      setIsLinkToMAS,
      setSearchedMasMid,
      showEntSerchResults,
      type,
    ])

    const getSelectedData = (selectedData: string) => {
      console.log('getSelectedData', selectedData)
      if (selectedData === 'Link to MAS') {
        setShowMasMidSearch(true)
        setEmsFlow(false)
      } else if (selectedData === 'Create only in EMS') {
        if (type === EmType.createSingleEntity) {
          isValidToProceed(true)
        }
        setShowMasMidSearch(false)
        setShowMasMidSearchResults(false)
        setEmsFlow(true)
      }
    }

    const onSearchPress = (searchStr: string) => {
      console.log('onSearchPress', searchStr)
      if (/^\d+$/.test(searchStr)) {
        if (type === EmType.createSingleEntity) {
          setGetEntityCalled(false)
          setMasMid(searchStr)
          setIsMasMidCleared(false)
          setClearMasMidText(false)
          setShowMasMidSearchResults(false)
          setIsLinkToMAS && setIsLinkToMAS(false)
          fetchSearch(searchStr, 'Entity ID', 'checkEntityPresence')
          setEntityData([])
        }
      } else {
        RootStore.message.setMessage('Invalid Id, Please enter numeric value', MessageTypes.ERROR)
      }
    }

    const onSearchParentClearPressed = () => {
      setSelectionsCleared(true)
      setSearchedMasMid('')
      setParentEntityIdSelected('')
      setIsLinkToMAS && setIsLinkToMAS(false)
      setShowMasMidSearch(false)
      setShowEntSerchResults(false)
      setShowMasMidSearchResults(false)
      setIsParentTypeSubGrpSelected(false)
      setShowSearchParentByEntId(false)
      setGroupSelectedTitle('')
      setSubGroupSelectedTitle('')
      setGroupListCalled(false)
      setParentTypeSelected('')
      setSearchListData([])
      if (type !== EmType.createSubGroup) {
        setGroupsListData([])
      }
      setParentEntitySearchString('')
      setEntityData([])
      if (type === EmType.createSingleEntity) {
        resetSearchEntity()
        // navigation.reset({
        //   index: 0,
        //   routes: [{ name: 'createSingleEntity' }],
        // })
      }
    }

    const getParentBySelectedData = (selectedData: string) => {
      if (enteredData === undefined) {
        setIsParentTypeSubGrpSelected(selectedData === 'SubGroup')
        setParentTypeSelectedToStore(selectedData)
        setShowSearchParentByEntId(selectedData === 'Entity')
        setIsMasMidCleared(true)
        setMasMid('')
        if (selectedData === 'SubGroup') {
          setParentTypeSelected('SubGroup')
          setShowEntSerchResults(false)
          setShowMasMidSearch(false)
          setShowMasMidSearchResults(false)
          if (groupsList().length === 0 && !groupListCalled) {
            fetchGroups('')
            setGroupListCalled(true)
          } else {
            const datalist = groupsList()
            setGroupsListData(datalist)
          }
        }
        if (selectedData === 'Entity') {
          setParentTypeSelected('Entity')
          setShowEntSerchResults(false)
          setGroupSelectedTitle('')
          setParentEntitySearchString('')
        }
        isValidToProceed(false)
      } else if (enteredData && enteredData?.entityParentType !== selectedData) {
        setEnteredData(undefined)
        resetSelections()
      }
    }

    const onSearchParentByPress = (searchStr: string) => {
      console.log('onSearchParentByPress', searchStr)
      if (/^\d+$/.test(searchStr)) {
        setEntityData([])
        setParentEntitySearchString(searchStr)
        setShowMasMidSearchResults(false)
        setShowEntSerchResults(false)
        setSearchedMidSource('')
        fetchSearch(searchStr, 'Entity ID', 'ALL')
      } else {
        RootStore.message.setMessage('Invalid Id, Please enter numeric value', MessageTypes.ERROR)
      }
    }

    const onParentGrpRowPress = (data: any) => {
      console.log('onParentGrpRowPress', data)
      setGroupSelectedTitle(data?.subGroupName ?? data?.groupName ?? data?.brandName)
      if (type !== EmType.createSubGroup) {
        setSubGroupSelectedTitle('')
        isValidToProceed && isValidToProceed(false)
        fetchSubGroups(data?.groupId, '')
      }
      if (type === EmType.createSubGroup) {
        isValidToProceed(true)
        setGroupSelected(data)
        setSubGroupSelectedData(data)
      } else if (type === EmType.createSingleEntity) {
        setGroupSelected(data)
        setEntityGrpIdSelected(data)
      }
    }

    const onParentSubGrpRowPress = (data: any) => {
      console.log('onParentSubGrpRowPress', data)
      setSubGroupSelectedTitle(data?.subGroupName ?? data?.groupName ?? data?.brandName)
      setSubGroupSelectedData(data)
      if (isParentTypeSubGrpSelected) {
        setShowEntSerchResults(true)
      }
      if (type === EmType.createSingleEntity) {
        isValidToProceed(true)
        setParentEntityIdSelected(data)
        setShowEntSerchResults(true)
        setShowMasMidSearch(true)
      }
    }

    const onEntitySearchResultsItemPress = (data: any) => {
      setViewDetailsSearchFlow(true)
      navigation.navigate('searchEntity', { data: data, from: 'CREATE_ENTITY' })
    }

    return (
      <Box f={1} overflow={'auto'} ph={PADDING_HORIZONTAL} pv={PADDING_VERTICAL} nativeID="vertical-scroll">
        <ModBox>
          <Text title={'Select Parent to Link'} color={'BLACK_21'} fontSize={18} fontFamily={'jiotype-bold'} />
          <ModBox {...styles.formWrapperContainer} show={type === EmType.createSingleEntity}>
            <SearchParentEntity
              title="Parent Type :"
              showRadioButtons={true}
              radioBtnTitles={['SubGroup', 'Entity']}
              placeholder={'Search parent by Entity ID…'}
              hideComponent={false}
              searchTitle={''}
              getSelectedData={getParentBySelectedData}
              showSearch={showSearchParentByEntId}
              onSearchPress={onSearchParentByPress}
              selectedRadioBtn={parentTypeSelected}
              isSearchLoading={masMid === '' && fetchSearchHandler?.state === 'pending'}
              onClearPressed={onSearchParentClearPressed}
              searchValue={parentEntitySearchId}
            />
          </ModBox>
          <ModBox show={parentTypeSelected === 'Entity' && showEntSerchResults} marginTop={16}>
            <SelectParentEntityList
              title={''}
              hide={EmType.createSingleEntity !== type}
              data={searchListData}
              columnFlexMapper={createEntityflexMapper}
              headerTitles={createEntityPIDHeaders}
              onItemPress={onEntitySearchResultsItemPress}
            />
          </ModBox>
          <ModBox
            show={
              (EmType.createSingleEntity === type && parentTypeSelected === 'SubGroup') ||
              EmType.createSubGroup === type
            }
            width={328}>
            <Spacer direction="vertical" size={16} />
            <Dropdown
              fullWidthContent={true}
              minWidth={328}
              type="table"
              label={'Parent Group'}
              title={'Select Parent Group'}
              value={groupSelectedTitle ?? ''}
              onTableItemPress={onParentGrpRowPress}
              tableData={groupsListData ?? []}
              data={[]}
              tableColumnMapper={flexMapperWithIndex}
              tableHeaderTitles={headerData}
              chevronColor={'PRIMARY'}
              isDataLoading={fetchGroupsListHandler?.state === 'pending'}
            />
          </ModBox>
          <Spacer direction="vertical" size={16} />
          <ModBox
            show={
              EmType.createSingleEntity === type &&
              groupSelectedTitle?.length > 0 &&
              fetchSubGroupsListHandler?.state !== 'rejected'
            }
            width={328}>
            <Dropdown
              fullWidthContent={true}
              minWidth={328}
              type="table"
              label={'Parent SubGroup'}
              title={'Select Parent Sub Group'}
              value={subGroupSelectedTitle ?? ''}
              onTableItemPress={onParentSubGrpRowPress}
              tableData={subGroupsListData ?? []}
              data={[]}
              tableColumnMapper={flexMapperWithIndex}
              tableHeaderTitles={subGrpheaderData}
              chevronColor={'PRIMARY'}
              isDataLoading={fetchSubGroupsListHandler?.state === 'pending'}
            />
          </ModBox>
          <ModBox show={EmType.createSingleEntity === type && showEntSerchResults}>
            <Spacer direction="vertical" size={8} />
            <SearchParentEntity
              hideComponent={false}
              title={''}
              showRadioButtons={true}
              placeholder="Search MAS-SMID/MID"
              searchTitle={'MAS-SMID/MID'}
              radioBtnTitles={[]}
              getSelectedData={getSelectedData}
              showSearch={showMasMidSearch}
              onSearchPress={onSearchPress}
              selectedRadioBtn={''}
              onClearPressed={onClearPressed}
              isSearchLoading={
                fetchGetMerchantHandler?.state === 'pending' ||
                (masMid !== '' && fetchSearchHandler?.state === 'pending')
              }
              clearSearchedText={clearSearchMasMidText}
              searchValue={masMid}
            />
            <ModBox
              marginTop={16}
              show={
                EmType.createSingleEntity === type &&
                showMasMidSearchResults &&
                entityData?.length > 0 &&
                !(
                  fetchGetMerchantHandler?.state === 'pending' ||
                  (masMid !== '' && fetchSearchHandler?.state === 'pending')
                )
              }>
              <SelectParentEntityList
                title={''}
                data={entityData}
                columnFlexMapper={createEntityMIDMASMapper}
                headerTitles={createEntityMASMIDHeaders}
                minHeight={230}
              />
            </ModBox>
          </ModBox>
        </ModBox>
      </Box>
    )
  },
)

export { CreateEntity }
